// extracted by mini-css-extract-plugin
export default {"cameraIcon":"CustomizeProfileTemplate_cameraIcon__GlHsI"};